/* eslint-disable no-param-reassign */
import axios, { AxiosRequestConfig } from 'axios';
import { getStorageValue } from '../hooks/useLocalStorage.ts';

// https://core.roktune.com/
// http://localhost:3005/

const resolveApiUrl = (): string => {
	const isLocalHost =
		typeof window !== 'undefined' &&
		(window.location.hostname === 'localhost' ||
			window.location.hostname === '127.0.0.1');

	if (!isLocalHost) {
		return 'https://core.roktune.com/';
	}

	return process.env.REACT_APP_API_URL || 'http://localhost:3005/';
};

export const API_URL = resolveApiUrl();
export const API_BASE_URL = API_URL.replace(/\/$/, '');

const axiosInstance = axios.create({
	baseURL: API_URL,
	headers: {
		'Content-type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	},
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
        (config: any) => {
                const stored = getStorageValue('accessToken', null);
                let accessToken = stored;
                if (stored && typeof stored === 'object' && stored.accessToken) {
                        accessToken = stored.accessToken;
                }
                if (accessToken) {
                        if (config.headers)
                                config.headers.Authorization = `Bearer ${accessToken}`;
                }
                return config;
	},
	(error) => Promise.reject(error)
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
	(response) => {
		if (response.data) {
			if (response.data.accessToken) {
				axiosInstance.defaults.headers.common.Authorization = `Bearer ${response.data.accessToken}`;
			}
		}
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return response;
	},
	(error) => {
		if (error.request.responseURL.includes('signin')) {
			return Promise.reject(error);
		}

		if (error.response?.status === 401) {
			localStorage.removeItem('accessToken');
			// window.location.replace('/');
		}
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		return Promise.reject(error);
	}
);

export default axiosInstance;